import React from "react";
import { Link } from "react-router-dom";
import { heroData, siteConfig, stats } from "../data/mockData";
import { Phone, Star, Shield, MapPin } from "lucide-react";

const HeroContent = () => (
  <div className="animate-fade-in-up">
    <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#E8F5E9] rounded-full text-sm text-[#3A7D44] font-medium mb-6">
      <Shield size={14} />
      Licensed in All 50 States
    </div>

    <h1
      className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1B2A1B] leading-tight mb-6"
      style={{ fontFamily: "'DM Sans', sans-serif" }}
    >
      Independent Health Insurance for <em className="italic text-[#3A7D44] not-italic-fix" style={{ fontStyle: 'italic' }}>Self-Employed Professionals</em> Who Want Coverage That Actually Fits
    </h1>

    <p className="text-lg sm:text-xl text-[#5A6B5A] leading-relaxed mb-8 max-w-lg">
      {heroData.subheadline}
    </p>

    <div className="flex flex-wrap gap-4 mb-10">
      <a
        href={siteConfig.calendlyUrl}
        className="inline-flex items-center px-7 py-3.5 text-base font-semibold text-white bg-[#3A7D44] rounded-lg hover:bg-[#2D5A35] transition-colors duration-200 shadow-lg shadow-[#3A7D44]/20"
      >
        {heroData.ctaPrimary.label}
      </a>
      <a
        href={`tel:${siteConfig.phone}`}
        className="inline-flex items-center gap-2 px-7 py-3.5 text-base font-semibold text-[#3A7D44] bg-white border-2 border-[#3A7D44]/20 rounded-lg hover:border-[#3A7D44]/40 hover:bg-[#F1F8F2] transition-colors duration-200"
      >
        <Phone size={18} />
        {siteConfig.phoneFormatted}
      </a>
    </div>

    <div className="flex flex-wrap items-center gap-6 text-sm text-[#5A6B5A]">
      <div className="flex items-center gap-1.5">
        <div className="flex">
          {[...Array(5)].map((_, i) => (
            <Star key={`hero-star-${i}`} size={14} className="text-yellow-500 fill-yellow-500" />
          ))}
        </div>
        <span className="font-semibold text-[#1B2A1B]">{stats.reviewScore}</span>
        <span>({stats.totalReviews} reviews)</span>
      </div>
      <div className="flex items-center gap-1.5">
        <MapPin size={14} className="text-[#3A7D44]" />
        <span>Raleigh, NC</span>
      </div>
    </div>
  </div>
);

const HeroImage = () => (
  <div className="relative animate-fade-in lg:flex justify-end" style={{ animationDelay: '0.3s' }}>
    <div className="relative">
      <div className="absolute -inset-4 bg-gradient-to-br from-[#3A7D44]/10 to-[#3A7D44]/5 rounded-3xl" />
      <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-[#3A7D44]/10">
        <img
          src={siteConfig.kimHeroPhoto}
          alt="Kimberly Hess - Health Insurance Broker"
          className="w-full max-w-md object-cover aspect-[3/4]"
        />
      </div>
    </div>
  </div>
);

const Hero = () => {
  return (
    <section className="relative min-h-[calc(100vh-80px)] flex items-center pt-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#F1F8F2] via-white to-[#E8F5E9]">
        <div className="absolute top-20 right-0 w-[600px] h-[600px] bg-[#3A7D44]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#3A7D44]/3 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <HeroContent />
          <HeroImage />
        </div>
      </div>
    </section>
  );
};

export default Hero;
